import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  CompletionCmsTexts,
  SaveFormCompletionDto,
} from '../../../types/Application/completion';
import { cmsApiConfig } from '../../../cmsConfig';
import { SaveFormResponse } from '../../../types/Application/application';

export const completionApi = createApi({
  reducerPath: 'completionApi',
  baseQuery: fetchBaseQuery({ baseUrl: cmsApiConfig.url }),
  endpoints: (builder) => ({
    getCompletionStartTexts: builder.query<CompletionCmsTexts, void>({
      query: () => `/newContractcompletion/getstarttexts/`,
    }),
    getCompletionFullTexts: builder.query<CompletionCmsTexts, void>({
      query: () => `/newcontractcompletion/getfulltexts/`,
      transformResponse: (response: CompletionCmsTexts) => {
        return response;
      },
    }),
    saveForm: builder.mutation<any, SaveFormCompletionDto>({
      query: (formData) => ({
        url: `/newContractCompletion/saveForm/`,
        method: 'POST',
        body: formData,
        cache: 'no-cache',
      }),
      transformResponse: (res: SaveFormResponse) => {
        const statusCode: SaveFormResponse = { statusCode: res.statusCode };
        return statusCode;
      },
      transformErrorResponse: (res) => {
        const { status } = res;
        return status;
      },
    }),
  }),
});

export const {
  useGetCompletionFullTextsQuery,
  useGetCompletionStartTextsQuery,
  useLazyGetCompletionStartTextsQuery,
  useLazyGetCompletionFullTextsQuery,
  useSaveFormMutation,
} = completionApi;
